import React, { useState, useEffect } from 'react';
import Login from '../components/Login';
import Dashboard from '../components/Dashboard';

export const AppGate: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('authToken') || localStorage.getItem('token');
    if (token) verifyToken(token);
    else setLoading(false);
  }, []);

  const verifyToken = async (token: string) => {
    try {
      const response = await fetch('/api/auth/verify', { headers: { Authorization: `Bearer ${token}` } });
      if (response.ok) setIsAuthenticated(true);
      else { localStorage.removeItem('authToken'); localStorage.removeItem('token'); }
    } catch { localStorage.removeItem('authToken'); localStorage.removeItem('token'); }
    finally { setLoading(false); }
  };

  const handleLoginSuccess = () => setIsAuthenticated(true);
  const handleLogout = () => { localStorage.removeItem('authToken'); localStorage.removeItem('token'); setIsAuthenticated(false); };

  if (loading) return (
    <div className="min-h-screen w-full flex items-center justify-center" style={{ backgroundColor: '#0f172a', minHeight: '100dvh' }}>
      <div className="text-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-violet-500 mx-auto" /><p className="mt-4 text-gray-400">Cargando FactuApp...</p></div>
    </div>
  );
  if (!isAuthenticated) return <Login onLoginSuccess={handleLoginSuccess} />;
  return <div className="App"><Dashboard onLogout={handleLogout} /></div>;
};
export default AppGate;
